import { Injectable } from '@angular/core';

import { Member } from '@zipari/shared-sbp-models';
import { StringService } from '@zipari/shared-sbp-services';

import { Coordinates } from './coordinates.interface';
import { QueryList } from './query-list.type';
import {
  doctorGenders,
  genders,
  providerSearchTypes,
} from './provider-search/provider-search.constant';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  constructor(private stringService: StringService) {}

  hasProviderResults: boolean;

  handleCheckboxRepeatedCommas(value: any): any {
    const stringValue = value.toString();
    if (stringValue.split(',').length > 1) {
      return value.filter((element) => element !== null && element !== '');
    }
  }

  /**
   * test that a provided coordinate set is a valid location to pass to map
   * @param coordinates longitude and latitude for a given map point
   */
  areValidCoordinates(coordinates: Coordinates): boolean {
    // Everything else is not on this planet.
    const latMax = 90;
    const latMin = -latMax;
    const lngMax = 180;
    const lngMin = -lngMax;

    if (coordinates.lat < latMin || coordinates.lat > latMax) {
      return false;
    } // Invalid latitude
    if (coordinates.lng < lngMin || coordinates.lng > lngMax) {
      return false;
    } // Invalid longitude
    return true;
  }

  getDirections = (address: string) =>
    `https://www.google.com/maps/dir/?api=1&origin=&destination=${address}`;

  /** Transforms a query list into a snake cased query string with queries separated by ampersands. */
  queryString = (queryList: QueryList): string => {
    const queryString = queryList
      .map((query) => `${query.parameter}=${query.value}`)
      .join('&');
    return this.stringService.snakeCase(queryString);
  };

  getProviderDetail(member: Member, whichWorkflow: string): string {
    return member.isMemberSelected
      ? whichWorkflow === providerSearchTypes.doctor
        ? 'Select PCP'
        : 'Select Primary Care Clinic'
      : whichWorkflow === providerSearchTypes.doctor
        ? 'PCP Not Yet Selected'
        : 'Primary Care Clinic Not Yet Selected';
  }

  public getDoctorsImage(gender: string): string {
    const doctorGender =
      gender.toLowerCase() === genders.male
        ? doctorGenders.male
        : doctorGenders.female;

    return `https://d32ul9oyxvd2n5.cloudfront.net/assets/${doctorGender}.svg`;
  }
}
